import { z } from 'zod';
import { daySchema } from './common';

/**
 * Fotografije napretka — `apps/api/src/routes/progress.ts`.
 *
 * Mjere (`measurementInput`) povijesno žive u `schemas/training.ts` i ostaju
 * ondje; ovdje su samo sheme koje su nedostajale, pa je portal fotografije
 * čitao kroz ručno prepisan tip (`takenAt`/`caption`) koji API nikad nije slao.
 *
 * PRIVATNOST: ove sheme opisuju ISKLJUČIVO klijentov pogled na vlastite
 * fotografije (`/v1/progress/photos`). Trenerov pogled je zasebna ruta
 * (`/v1/progress/photos/:clientId`) koju server pušta samo uz
 * `coaching_relationships.photo_access_granted_at` i koja namjerno ne vraća
 * `note`. Ugovor je ovdje ne izlaže — klijentski ekran je nema zašto zvati.
 */
export const photoPoseSchema = z.enum(['front', 'side', 'back', 'other']);

export const progressPhotoConfirmInput = z.object({
  /** Ključ koji je izdao `/photos/upload-url`; server provjerava da je klijentov. */
  key: z.string().min(1).max(300),
  takenOn: daySchema,
  pose: photoPoseSchema.default('front'),
  note: z.string().max(500).optional(),
});

/** Zapis nastaje TEK pri potvrdi, kad objekt stvarno postoji u R2. */
export const progressPhotoConfirmedOutput = z.object({ photoId: z.string() });

export const progressPhotoOutput = z.object({
  id: z.string(),
  takenOn: z.string(),
  pose: photoPoseSchema,
  note: z.string().nullable(),
  /** Potpisani URL s TTL-om od 5 minuta — nikad trajna putanja do bucketa. */
  url: z.string(),
});

export const progressPhotoListOutput = z.object({ items: z.array(progressPhotoOutput) });

export type PhotoPose = z.infer<typeof photoPoseSchema>;
export type ProgressPhotoConfirmInput = z.infer<typeof progressPhotoConfirmInput>;
export type ProgressPhotoOutput = z.infer<typeof progressPhotoOutput>;
export type ProgressPhotoListOutput = z.infer<typeof progressPhotoListOutput>;
